/**
 * Account Entity - Domain Types
 *
 * Read-only representation of Dynamics CRM Accounts.
 * The Accounts table is the system of record — this app never writes to it.
 * Used primarily for Groups (customertypecode filtering).
 */

// =============================================================================
// Core Types
// =============================================================================

export interface Account {
  id: string;
  name: string;
  accountNumber?: string;
  customerTypeCode?: number;
  customerTypeName?: string;
  stateCode?: number;
  email?: string;
  phone?: string;
  city?: string;
  state?: string;
  /** Broker of Record (lookup → contact). dts_brokerofrecord on account. */
  brokerOfRecordContactId?: string;
  brokerOfRecordName?: string;
}

// =============================================================================
// Customer Type Option Set (fetched dynamically from Dataverse metadata)
// =============================================================================

export interface CustomerTypeOption {
  value: number;
  label: string;
}

/**
 * Labels that identify "group" account types.
 * These labels are consistent across environments even when integer codes differ.
 */
export const GROUP_TYPE_LABELS = ['Group', 'Prospect Group'] as const;

// =============================================================================
// Query Types
// =============================================================================

export interface AccountQueryParams {
  /** Search by name (contains) */
  nameFilter?: string;
  /** Filter to specific customer type codes */
  customerTypeCodes?: number[];
  /** Only active accounts */
  activeOnly?: boolean;
  /** Max results */
  top?: number;
}
